import React, { ReactNode } from "react";
import { RLCard } from "../../../../components";

import Typography from "../../../../components/typography/Typography";
import styles from "./common.module.scss";

interface Props {
  title: ReactNode;
  headerLinkComp?: ReactNode;
}
const TableHeader: React.FC<Props> = ({ title, headerLinkComp }) => (
  <RLCard.Header
    className={`${styles.header_border_radius} flex justify-content-space-between`}
  >
    <Typography variant="h5" tag="div">
      {title}
    </Typography>
    {headerLinkComp}
  </RLCard.Header>
);
export default TableHeader;
